export const pageSizes = [
  {'text': '5', 'value': 5},
  {'text': '10', 'value': 10},
  {'text': '20', 'value': 20},
  {'text': '50', 'value': 50},
  {'text': '100', 'value': 100},
  {'text': '500', 'value': 500},
];

export const pageSizeFloatingInventory = [
  {'text': '10', 'value': 10},
  {'text': '20', 'value': 20},
  {'text': '50', 'value': 50},
];

export const invoicesPageSizes = [
  {'text': '10', 'value': 10},
  {'text': '20', 'value': 20},
  {'text': '30', 'value': 30},
  {'text': '40', 'value': 40},
  {'text': '50', 'value': 50},
];

export const invoicesPageSizesCustomOrders = [
  {'text': '10', 'value': 10},
  {'text': '20', 'value': 20},
  {'text': '30', 'value': 30},
  {'text': '50', 'value': 50},
  {'text': '100', 'value': 100},
  {'text': '200', 'value': 200},
  {'text': '500', 'value': 500},
];

export const specialOrdersTransportation = [
  {'text': 'VOR', 'value': 'V'},
  {'text': 'MARÍTIMA', 'value': 'M'},
  {'text': 'AÉREA', 'value': 'A'},
];

export const dealerList = [
  {'text': 'TODOS LOS CONCESIONARIOS', 'value': 'all'},
  {'text': 'AUTOMOTORES CARLOS LARREA T.CIA.LTDA', 'value': '1891709478001', 'alias': 'CL'},
  {'text': 'CASABACA S.A.', 'value': '1790009459001', 'alias': 'CB'},
  {'text': 'COMERCIAL HIDROBO S.A.', 'value': '1090084247001', 'alias': 'CH'},
  {'text': 'IMPORTADORA TOMEBAMBA S.A.', 'value': '0190003701001', 'alias': 'IT'},
  {'text': 'SKIODA', 'value': '1790656934001', 'alias': 'SK'},
  {'text': 'TOYOCOSTA S. A.', 'value': '0993144029001', 'alias': 'TC'},
];

export const dealerListMaintain = [
  {'text': 'AUTOMOTORES CARLOS LARREA T.CIA.LTDA', 'value': '1891709478001', 'alias': 'CL'},
  {'text': 'CASABACA S.A.', 'value': '1790009459001', 'alias': 'CB'},
  {'text': 'COMERCIAL HIDROBO S.A.', 'value': '1090084247001', 'alias': 'CH'},
  {'text': 'IMPORTADORA TOMEBAMBA S.A.', 'value': '0190003701001', 'alias': 'IT'},
  {'text': 'SKIODA', 'value': '1790656934001', 'alias': 'SK'},
  {'text': 'TOYOCOSTA S. A.', 'value': '0993144029001', 'alias': 'TC'},
  {'text': 'TOYOTA DEL ECUADOR S.A', 'value': '1792073634001', 'alias': 'TE'},
  {'text': 'TOYOTA TSUSHO CORPORATION', 'value': '9999999999996', 'alias': 'TT'},
  {'text': 'CORPORACION NEXUM NEXUMCORP S.A', 'value': '0992141913001', 'alias': 'NX'},
];

export const dealerListForForcastSale = [
  ...dealerList,
  {'text': 'TOYOTA DEL ECUADOR S.A', 'value': '1792073634001', 'alias': 'TE'},
  {'text': 'TOYOTA TSUSHO CORPORATION', 'value': '9999999999996', 'alias': 'TT'},
];

export const dealerOrderStatus = [
  {'text': 'INGRESADO', 'value': 'Ingresado'},
  {'text': 'PROCESADO', 'value': 'Procesado'},
  {'text': 'EN TRÁNSITO', 'value': 'En Tránsito'},
  {'text': 'ETIQUETADO', 'value': 'Etiquetado'},
  {'text': 'FACTURADO', 'value': 'Facturado'},
  {'text': 'RECHAZADO', 'value': 'Rechazado'},
  {'text': 'NEGADO', 'value': 'Negado'},
  {'text': 'ELIMINADO', 'value': 'Eliminado'},
];

export const dealerOrderTypes = [
  {'text': 'STOCK', 'value': 'S'},
  {'text': 'EMERGENTE', 'value': 'E'},
  {'text': 'ESPECIAL', 'value': 'P'},
];

export const vehicleMasterRequestStatus = [
  {'text': 'Producto', 'value': 'product'},
  {'text': 'Ventas', 'value': 'sales'},
  {'text': 'Servicio', 'value': 'service'},
  {'text': 'Importaciones', 'value': 'importations'},
  {'text': 'Jde', 'value': 'jde'},
];

export const warehouseOptions = [
  {'key': '1', 'value': 'TODOS', 'text': 'TODOS'},
  {'key': '2', 'value': '1CPD', 'text': 'CPD'},
  {'key': '3', 'value': '1LAC', 'text': 'LOG'},
  {'key': '4', 'value': '1LBR', 'text': 'LUB'},
  {'key': '5', 'value': '1DRS', 'text': 'DIS'},
];

export const viewOptions = [
  {'text': 'Todos', 'value': 'all'},
  {'text': 'Con Stock', 'value': 'true'},
  {'text': 'Sin Stock', 'value': 'false'},
];

export const reasonsOptions = [
  {'text': 'Falta de Stock', 'value': 'Falta de Stock'},
  {'text': 'Precio', 'value': 'Precio'},
  {'text': 'Pedido de stock cancelado', 'value': 'Pedido de stock cancelado'},
];

export const IccOptions = [
  {'key': '', 'text': 'TODO', 'value': ''},
  {'key': 'ACCESORIOS', 'text': 'ACCESORIOS', 'value': 'ACCESORIOS'},
  {'key': 'REPUESTOS', 'text': 'REPUESTOS', 'value': 'REPUESTOS'},
  {'key': 'OTROS', 'text': 'OTROS', 'value': 'OTROS'},
];

export const orderTypes = [
  {'text': 'Normal', 'value': 'NORMAL'},
  {'text': 'INEN', 'value': 'INEN'},
];

export const transportTypes = [
  {'text': 'Aéreo', 'value': 'AÉREO'},
  {'text': 'Marítimo', 'value': 'MARÍTIMO'},
  {'text': 'VOR', 'value': 'VOR'},
];

export const invoiceQueryStatus = [
  {'value': 'I', 'text': 'Ingresada'},
  {'value': 'P', 'text': 'Procesada'},
  {'value': 'C', 'text': 'Confirmada'},
];

export const manualsValues = [
  'manualSafetyStockMadAOne',
  'manualSafetyStockMadATwo',
  'manualSafetyStockMadAThree',
  'manualSafetyStockMadAFour',
  'manualSafetyStockMadAFive',
  'manualSafetyStockMadBOne',
  'manualSafetyStockMadBTwo',
  'manualSafetyStockMadBThree',
  'manualSafetyStockMadBFour',
  'manualSafetyStockMadBFive',
  'manualSafetyStockMadCOne',
  'manualSafetyStockMadCTwo',
  'manualSafetyStockMadCThree',
  'manualSafetyStockMadCFour',
  'manualSafetyStockMadCFive',
  'manualSafetyStockMadDOne',
  'manualSafetyStockMadDTwo',
  'manualSafetyStockMadDThree',
  'manualSafetyStockMadDFour',
  'manualSafetyStockMadDFive',
  'manualSafetyStockMadEOne',
  'manualSafetyStockMadETwo',
  'manualSafetyStockMadEThree',
  'manualSafetyStockMadEFour',
  'manualSafetyStockMadEFive',
];

export const typeOption = [
  {'key': '1', 'value': 'R', 'text': 'REPUESTOS'},
  {'key': '2', 'value': 'A', 'text': 'ACCESORIOS'},
  {'key': '3', 'value': 'L', 'text': 'LUBRICANTES'},
  {'key': '4', 'value': 'T', 'text': 'TODOS'},
];

export const iccOption = [
  {'key': '1', 'value': 'A1', 'text': 'A1'},
  {'key': '2', 'value': 'A2', 'text': 'A2'},
  {'key': '3', 'value': 'A3', 'text': 'A3'},
  {'key': '4', 'value': 'A4', 'text': 'A4'},
  {'key': '5', 'value': 'A5', 'text': 'A5'},
  {'key': '6', 'value': 'B1', 'text': 'B1'},
  {'key': '7', 'value': 'B2', 'text': 'B2'},
  {'key': '8', 'value': 'B3', 'text': 'B3'},
  {'key': '9', 'value': 'B4', 'text': 'B4'},
  {'key': '10', 'value': 'B5', 'text': 'B5'},
  {'key': '11', 'value': 'C1', 'text': 'C1'},
  {'key': '12', 'value': 'C2', 'text': 'C2'},
  {'key': '13', 'value': 'C3', 'text': 'C3'},
  {'key': '14', 'value': 'C4', 'text': 'C4'},
  {'key': '15', 'value': 'C5', 'text': 'C5'},
  {'key': '16', 'value': 'D1', 'text': 'D1'},
  {'key': '17', 'value': 'D2', 'text': 'D2'},
  {'key': '18', 'value': 'D3', 'text': 'D3'},
  {'key': '19', 'value': 'D4', 'text': 'D4'},
  {'key': '20', 'value': 'D5', 'text': 'D5'},
  {'key': '21', 'value': 'E1', 'text': 'E1'},
  {'key': '22', 'value': 'E2', 'text': 'E2'},
  {'key': '23', 'value': 'E3', 'text': 'E3'},
  {'key': '24', 'value': 'E4', 'text': 'E4'},
  {'key': '25', 'value': 'E5', 'text': 'E5'},
  {'key': '27', 'value': 'F1', 'text': 'F1'},
  {'key': '28', 'value': 'F2', 'text': 'F2'},
  {'key': '29', 'value': 'F3', 'text': 'F3'},
  {'key': '30', 'value': 'F4', 'text': 'F4'},
  {'key': '31', 'value': 'F5', 'text': 'F5'},
];

export const dealerListForVehiclesSummary = [
  {'text': 'CASABACA S.A.', 'value': '1790009459001', 'alias': 'CB'},
  {'text': 'IMPORTADORA TOMEBAMBA S.A.', 'value': '0190003701001', 'alias': 'IT'},
  {'text': 'TOYOCOSTA S. A.', 'value': '0993144029001', 'alias': 'TC'},
  {'text': 'SKIODA', 'value': '1790656934001', 'alias': 'SK'},
  {'text': 'SUBCONCESIONARIOS', 'value': 'sub', 'alias': 'SUB'},
  {'text': 'TOTAL', 'value': 'total', 'alias': 'TOT'},
];

export const requestsDeviceType = [
  {'text': 'DESINSTALACIÓN', 'value': 'D'},
  {
    'text': 'REINSTALACIÓN',
    'value': 'R',
  },
];


export const dealerListForVehiclesSummaryStock = [
  {'text': 'CASABACA S.A.', 'value': '1790009459001', 'alias': 'CB'},
  {'text': 'IMPORTADORA TOMEBAMBA S.A.', 'value': '0190003701001', 'alias': 'IT'},
  {'text': 'TOYOCOSTA S. A.', 'value': '0993144029001', 'alias': 'TC'},
  {'text': 'SKIODA', 'value': '1790656934001', 'alias': 'SK'},
  {'text': 'SUBCONCESIONARIOS', 'value': 'sub', 'alias': 'SUB'},
  {'text': 'TOTAL', 'value': 'total', 'alias': 'TOT'},
  {'text': 'MS', 'value': 'monthsStock', 'alias': 'MESES STOCK'},
];


export const dealerListForVehiclesSummarySales = [
  {'text': 'CASABACA S.A.', 'value': '1790009459001', 'alias': 'CB'},
  {'text': 'IMPORTADORA TOMEBAMBA S.A.', 'value': '0190003701001', 'alias': 'IT'},
  {'text': 'TOYOCOSTA S. A.', 'value': '0993144029001', 'alias': 'TC'},
  {'text': 'SKIODA', 'value': '1790656934001', 'alias': 'SK'},
  {'text': 'SUBCONCESIONARIOS', 'value': 'sub', 'alias': 'SUB'},
  {'text': 'TOTAL', 'value': 'total', 'alias': 'TOT'},
  {'text': 'TASACIERRE', 'value': 'tasCierre', 'alias': 'TASA CIERRE'},
];
